import React from "react";
import BookingContainer from "../containers/Booking";

const Booking = () => {
  return <BookingContainer />;
};

export default Booking;
